import { BACKFILL_QUERY_SCOPE_OPTIONS, BackfillQueryScopeOptions } from '@vy/types';
import { type ChangeEvent, type FC, useState } from 'react';
import { VyDialog } from '../../../../../../../../components/new-design/feedback/VyDialog';
import { VyRadio } from '../../../../../../../../components/new-design/inputs/VyRadio/VyRadio';
import { VyRadioGroup } from '../../../../../../../../components/new-design/inputs/VyRadio/VyRadioGroup';

type BackfillAnrokTransactionsDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: (scope: BackfillQueryScopeOptions) => void;
  isLoading: boolean;
};

const SCOPE_OPTIONS: { value: BackfillQueryScopeOptions; label: string }[] = [
  { value: BACKFILL_QUERY_SCOPE_OPTIONS.ALL, label: 'All customers' },
  { value: BACKFILL_QUERY_SCOPE_OPTIONS.AUTOMATIC_TAX_ONLY, label: 'Only customers with automatic tax' },
];

export const BackfillAnrokTransactionsDialog: FC<BackfillAnrokTransactionsDialogProps> = ({
  open,
  onClose,
  onConfirm,
  isLoading,
}) => {
  const [scope, setScope] = useState<BackfillQueryScopeOptions>(BACKFILL_QUERY_SCOPE_OPTIONS.ALL);

  const handleScopeChange = (event: ChangeEvent<HTMLInputElement>) => {
    setScope(event.target.value as BackfillQueryScopeOptions);
  };

  return (
    <VyDialog
      open={open}
      onClose={onClose}
      fullWidth
      label="Backfill Historical Transactions"
      labelDescription="Choose which customers to backfill transactions for in Anrok."
      ctaText="Backfill"
      ctaDisabled={isLoading}
      onSubmit={() => onConfirm(scope)}
    >
      <VyRadioGroup
        value={scope}
        onChange={handleScopeChange}
        options={SCOPE_OPTIONS}
        renderOption={(option, _index, isActive) => (
          <VyRadio key={option.value} value={option.value} label={option.label} selected={isActive} />
        )}
      />
    </VyDialog>
  );
};
